import type { MultiHeaderWidgetOption } from "shared/components/widgets/MultiHeaderWidget.vue";
import type { ChartIndex } from "shared/modules/Charts/types";
import { MediaRelease } from "shared/resources";
import createInsightsService from "shared/services/api/InsightsServiceFactory";

export function useInstantInsights() {
  function loadAvailableCharts({
    publicAccessKey,
  }: { publicAccessKey?: string } = {}): Promise<ChartIndex> {
    const service = createInsightsService({ publicAccessKey });

    return service.chartsConfig();
  }

  async function loadMediaReleasesHeaderOptions(
    mediaReleaseIds: number[]
  ): Promise<MultiHeaderWidgetOption[]> {
    const response = await MediaRelease.where({
      id: mediaReleaseIds,
    }).all();

    return response.data.map((release) => ({
      id: Number(release.id),
      label: release.name,
    }));
  }

  return {
    loadAvailableCharts,
    loadMediaReleasesHeaderOptions,
  };
}

export default useInstantInsights;
